import { useState, useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import skillsbridgeLogo from '../img/skillsbridge.png';
import './pStyles/UserLayout.css';

export default function UserLayout() {
    const [activeView, setActiveView] = useState('home');
    const [menuOpen, setMenuOpen] = useState(false); 
    const location = useLocation();
    const navigate = useNavigate();
  
    // active view based on current location
    useEffect(() => {
      const path = location.pathname;
      if (path === '/' || path === '/landing') {
        setActiveView('home');
      } else if (path === '/about') {
        setActiveView('about');
      } else if (path === '/projects') {
        setActiveView('projects');
      } else if (path === '/forum') {
        setActiveView('forum');
      } else if (path === '/donations') {
        setActiveView('donations');
      } else if (path === '/map') {
        setActiveView('map');
      }
    }, [location]);
  
    const toggleMenu = () => {
      setMenuOpen(!menuOpen);
    };

    return (
      <div className="user-container">
        {/* Navigation matching landing page design */}
        <header className="landing-nav">
          <div className="landing-nav-container">
            <Link to="/" className="landing-logo">
              <img src={skillsbridgeLogo} alt="SkillsBridge" className="logo-image" />
              SkillsBridge
            </Link>
            
            {/* Mobile menu toggle */}
            <button 
              className="menu-toggle" 
              onClick={toggleMenu}
              aria-expanded={menuOpen}
              aria-label="Toggle navigation menu"
            >
              <span className="menu-icon"></span>
            </button>
            
            <nav className={`landing-nav-links ${menuOpen ? 'active' : ''}`}>
              <Link 
                to="/" 
                onClick={() => {setActiveView('home'); setMenuOpen(false);}} 
                className={`nav-link ${activeView === 'home' ? 'active' : ''}`}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                onClick={() => {setActiveView('about'); setMenuOpen(false);}}
                className={`nav-link ${activeView === 'about' ? 'active' : ''}`}
              >
                About
              </Link>
              <Link 
                to="/projects" 
                onClick={() => {setActiveView('projects'); setMenuOpen(false);}}
                className={`nav-link ${activeView === 'projects' ? 'active' : ''}`}
              >
                Projects
              </Link>

              <Link 
                to="/map" 
                onClick={() => {setActiveView('map'); setMenuOpen(false);}}
                className={`nav-link ${activeView === 'map' ? 'active' : ''}`}
              >
                Map
              </Link>
              
              <Link 
                to="/forum" 
                onClick={() => {setActiveView('forum'); setMenuOpen(false);}}
                className={`nav-link ${activeView === 'forum' ? 'active' : ''}`}
              >
                Reviews
              </Link>
              <Link 
                to="/donations" 
                onClick={() => {setActiveView('donations'); setMenuOpen(false);}}
                className={`nav-link ${activeView === 'donations' ? 'active' : ''}`}
              >
                Donations
              </Link>
              
            </nav>

            <div className="landing-nav-actions">
              <Link 
                to="/login" 
                onClick={() => setMenuOpen(false)}
                className="nav-button login"
              >
                Login
              </Link>  
              <Link 
                to="/application" 
                onClick={() => setMenuOpen(false)}
                className="nav-button join-now"
              >
                Join Now
              </Link>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="user-content">
          <Outlet />
        </main>
      </div>
    );
}